import React from "react";
import NavAdmin from "../nav-admin/nav-admin";
import useUserStore from "../../utils/storeApp";

const HeaderAccount = () => {
  const { userRole } = useUserStore((state) => ({
    userRole: state.userRole,
  }));
  return (
    <div className="HeaderAccount">
      {userRole === "SES ADMINISTRATOR" || userRole === "ADMINISTRATOR" ? (
        <section>
          <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar">
            <div className="container w-max2">
              {/*Main Header*/}
              <div className="admin-title">
                <i
                  className="bi bi-card-checklist"
                  aria-labelledby="Account Setting"
                ></i>{" "}
                <span className="spacer-margin2">Account Setting</span>
              </div>
              {/*Admin Menus*/}
              <NavAdmin />
            </div>
          </nav>
        </section>
      ) : null}
    </div>
  );
};

HeaderAccount.defaultProps = {};

export default HeaderAccount;
